module.exports = __webpack_public_path__ + "resources/img/img_docuone_m.a7cd9de6960d63d5bcb0d6d24141bc95.png";